import { Component, OnInit, Inject } from '@angular/core';
import { TokenStorageService } from '../../services/token-storage.service';
import { Router } from '@angular/router';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ErrorhandlingService } from 'src/app/services/errorhandling.service';
import { UserDTO } from 'src/app/interfaces/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { firstValueFrom } from 'rxjs';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-login',
  imports: [FormsModule, MatLabel, MatFormFieldModule, MatProgressSpinnerModule, NgIf, MatInputModule, MatButtonModule, MatDividerModule, MatIconModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {
  form: any = {
    email: null,
    password: null,
    resetEmail: null
  };
  user: UserDTO;
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  role: string;
  hide = true;
  reset = false;
  loginForm: FormGroup;
  showSpinner: boolean = false;
  deviceId: string = "";

  constructor(private errorhandling: ErrorhandlingService,
    private router: Router, private tokenStorage: TokenStorageService, private authenticationService: AuthenticationService, public dialogRef: MatDialogRef<LoginComponent>, @Inject(MAT_DIALOG_DATA) data) { }

  ngOnInit(): void {
    this.deviceId = this.tokenStorage.getDeviceId();
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
    }
    this.loginForm = new FormGroup({
      email: new FormControl(this.form.email, [
        Validators.email
      ]),
      subject: new FormControl(this.form.password,
        [Validators.required]),
      resetEmail: new FormControl(this.form.resetEmail, [Validators.email])
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  login() {
    if (this.isLoginFailed) {
      this.showSpinner = true;
      setTimeout(() => {
        this.loginUser();
      },
        3000);
    } else {
      this.loginUser();
    }
  }

  async loginUser() {
    const { email, password } = this.form;

    try {
      const data = await firstValueFrom(this.authenticationService.login(email, password, this.deviceId));
      if (data) {
        this.user = data;
        this.tokenStorage.saveToken(data.accessToken);
        this.tokenStorage.saveRefreshToken(data.refreshToken);
        this.tokenStorage.saveUser(this.user);

        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.role = this.user.role;
        if (this.isLoggedIn) {
          this.dialogRef?.close({ data: true });
        }
        this.showSpinner = false;
      } else {
        this.tokenStorage.saveToken(null);
        this.tokenStorage.saveRefreshToken(null);
        this.isLoginFailed = true;
        this.errorMessage = "Incorrect email and/or password";
        this.showSpinner = false;
      };
    } catch (error) {
      this.tokenStorage.saveToken(null);
      this.tokenStorage.saveRefreshToken(null);
      this.tokenStorage.signOut();
      this.isLoginFailed = true;
      this.errorMessage = "Incorrect email and/or password";
      this.showSpinner = false;
      this.dialogRef.updateSize('480px', '380px');
    }
  }

  elapseReset() {
    this.reset = true;
    this.isLoginFailed = false;
    this.dialogRef.updateSize('480px', '500px');
  }

  async resetPassword() {
    const data = await firstValueFrom(this.authenticationService.resetPassword(this.form.email));
    if (data) {
      this.dialogRef.close();
    }
  }

  get email() { return this.loginForm.get('email'); }
  get password() { return this.loginForm.get('password'); }
  get resetEmail() { return this.loginForm.get('resetEmail'); }
}